import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ModelNumStr, ModelNumStrNav, TicketsTipo, ITicketsTipo_TableModel } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsTipoService extends CrudGenericsService<TicketsTipo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsTipo`);
    this.base = `${env.apiUrl}/api/TicketsTipo/`;
  }

  GetTicketsTipo_Codici(): Observable<ModelNumStr[]> {
    const url = this.base + 'GetTicketsTipo_Codici';
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
  // web
  Get4Select_TicketCategoriaNavigation(): Observable<ModelNumStrNav[]> {
    const url = this.base + 'Get4Select_TicketCategoriaNavigation';
    return this.http.get<ModelNumStrNav[]>(`${url}`);
  }
  // web
  GetSingle_TicketsTipoTableModel(id: number): Observable<ITicketsTipo_TableModel> {
    const url = this.base + 'GetSingle_TicketsTipoTableModel?id=' + id;
    return this.http.get<ITicketsTipo_TableModel>(`${url}`);
  }
  // web
  GetAll_TicketsTipoTableModel(): Observable<ITicketsTipo_TableModel[]> {
    const url = this.base + 'GetAll_TicketsTipoTableModel';
    return this.http.get<ITicketsTipo_TableModel[]>(`${url}`);
  }
}
